/** Warm light shell — matches SimCollect primary / accent (not dark ops chrome). */
export const SIDEBAR_ASIDE =
  "relative flex h-full shrink-0 flex-col border-r border-primary/10 bg-[#fffcf7] shadow-[inset_-1px_0_0_rgba(59,47,41,0.06)] transition-[width] duration-300 ease-in-out";

export const SIDEBAR_HEADER_BORDER = "border-b border-primary/10";
export const SIDEBAR_GROUP_LABEL = "mb-2 px-3 text-[10px] font-bold uppercase tracking-[0.18em] text-primary/35";
export const SIDEBAR_FOOTER_BORDER = "border-t border-primary/10";

export function navLinkClass({ isActive, collapsed }) {
  const base = `group relative flex items-center rounded-xl text-sm font-medium transition-all duration-200 ${
    collapsed ? "justify-center px-2 py-2.5" : "gap-3 px-3 py-2.5"
  }`;
  if (isActive) {
    return `${base} bg-accent/15 text-primary shadow-sm ring-1 ring-accent/20`;
  }
  return `${base} text-primary/55 hover:bg-primary/[0.04] hover:text-primary`;
}

export function navIconWrapClass(isActive) {
  return `flex h-8 w-8 shrink-0 items-center justify-center rounded-lg transition-colors ${
    isActive ? "bg-accent/25 text-primary" : "bg-primary/[0.05] text-primary/45 group-hover:bg-primary/[0.08] group-hover:text-primary/70"
  }`;
}

export function subNavLinkClass(isActive, nested = false) {
  return `block rounded-lg py-1.5 text-[12px] font-medium leading-snug transition-colors ${
    nested ? "pl-3 pr-2" : "px-2"
  } ${isActive ? "bg-accent/15 text-primary" : "text-primary/45 hover:bg-primary/[0.04] hover:text-primary"}`;
}

export const SECTION_HEADER_ACTIVE =
  "bg-accent/15 text-primary shadow-sm ring-1 ring-accent/20";
export const SECTION_HEADER_INACTIVE =
  "text-primary/55 hover:bg-primary/[0.04] hover:text-primary";

export const USER_CARD_BUTTON =
  "w-full rounded-xl border border-primary/10 bg-white/90 shadow-sm transition-colors hover:bg-white hover:shadow-md";
export const USER_MENU_PANEL =
  "absolute z-50 w-56 rounded-xl border border-primary/10 bg-[#fffcf7] p-1.5 shadow-xl ring-1 ring-primary/5";
export const USER_MENU_ITEM =
  "flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-primary/75 transition-colors hover:bg-primary/[0.05] hover:text-primary";
